enum ActionTypes {
	requestReset = 'PasswordChange.requestReset',
	receiveReset = 'PasswordChange.receiveReset',
	requestPasswordUpdate = 'PasswordChange.requestPasswordUpdate',
	receivePasswordUpdate = 'PasswordChange.receivePasswordUpdate',
}

export default ActionTypes;
